import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { F, isNil } from 'ramda';

import FastCashPresenter from '../../../../../../presenters/FastCashPresenter';
import SpecialCashbackRatePresenter from '../../../../../../presenters/SpecialCashbackRatePresenter';
import UserPresenter from '../../../../../../presenters/UserPresenter';
import CheckInPresenter from '../../../../../../presenters/FastCash/CheckInPresenter';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import Group from '../../../../../../components/Group';
import { Label } from '../../../../../../components';
import Value from '../../../../../../components/Value';
import Modal from '../../../../../../components/Modal';

const CashbackInfo = (props) => {
  const {
    fastCash,
    isFlagUser,
    handleFlagUser,
    handleUnFlagUser,
    specialCashbackRates,
  } = props;

  const userHasFastCash = !isNil(fastCash);
  const [cashbackRate, setCashbackRate] = useState(
    !isNil(fastCash?.specialCashbackRate?.cashbackRate) &&
      fastCash?.specialCashbackRate?.cashbackRate
  );
  const [comment, setComment] = useState('');
  const [showErrorComment, setShowErrorComment] = useState(false);
  const [showErrorRate, setShowErrorRate] = useState(false);
  const [showAllHistory, setShowAllHistory] = useState(false);
  const [sortedComments, setSortedComments] = useState([]);
  const [showComment, setShowComment] = useState(
    fastCash?.specialCashbackRate?.cashbackRate !== cashbackRate && isFlagUser
  );

  useEffect(() => {
    if (!isFlagUser && !isNil(cashbackRate)) {
      setCashbackRate(null);
    }
    showCommentInput();
  }, [isFlagUser]);

  useEffect(() => {
    sortByDate();
  }, [specialCashbackRates]);

  const showCommentInput = () => {
    if (
      fastCash?.specialCashbackRate?.cashbackRate !== cashbackRate &&
      isFlagUser
    ) {
      setShowComment(true);
      return;
    }
    setComment('');
    setShowComment(false);
  };

  const handleChange = ({ target: { value } }) => {
    if (parseInt(value) > 15 || parseInt(value) < 0) {
      return;
    }
    setShowErrorRate(false);
    setCashbackRate(value);
  };

  const handleUnFlag = () => {
    setShowErrorRate(false);
    setCashbackRate(null);
    handleUnFlagUser();
  };

  const validateComment = () => {
    if (comment == '') {
      setShowComment(true);
      setShowErrorComment(true);
      return;
    }
    setShowErrorComment(false);
  };

  const validateRate = () => {
    if (cashbackRate == '' || isNil(cashbackRate)) {
      setShowErrorRate(true);
      return;
    }
    setShowErrorRate(false);
  };

  const handleFlag = async () => {
    await validateComment();
    await validateRate();
    handleFlagUser({ cashbackRate, comment });
  };

  const handleChangeComment = ({ target }) => {
    const { value } = target;
    setComment(value);
    setShowErrorComment(false);
  };

  const sortByDate = async () => {
    let array = [...specialCashbackRates];
    let sorted = array.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
    setSortedComments(sorted);
  };

  return (
    <div>
      <Group title="Cashback Rate">
        <Row className="wrapper">
          <Column>
            <Row>
              <input
                type="number"
                id="cashbackRate"
                value={parseInt(cashbackRate)}
                onChange={handleChange}
                className="input-percentage"
                disabled={!isFlagUser}
              />
              {cashbackRate !== '' && !isNil(cashbackRate) && (
                <div
                  className={`text-percentage ${
                    parseInt(cashbackRate) < 10 ? 'percentage-0' : ''
                  }${parseInt(cashbackRate) >= 100 ? 'percentage-100' : ''}
                  ${showErrorRate ? 'with-error' : ''}`}
                >
                  %
                </div>
              )}
              {isFlagUser && (
                <button className="button -in-group" onClick={handleFlag}>
                  Edit Amount
                </button>
              )}
              {userHasFastCash &&
                (isFlagUser ? (
                  <button
                    className="button red-border -in-group"
                    onClick={handleUnFlag}
                  >
                    Un-flag User
                  </button>
                ) : (
                  <button
                    className="button red-border"
                    onClick={handleFlagUser}
                  >
                    Flag User
                  </button>
                ))}
            </Row>
            {showErrorRate && (
              <text className="redText">Rate can't be blank</text>
            )}
          </Column>
        </Row>
        {showComment && (
          <Row>
            <Column className="margin-top">
              <Label attr="Comment" text="Write why this user was flagged:" />
              <textarea
                id="comment"
                value={comment}
                onChange={handleChangeComment}
                className="textarea"
              />
              <Row>
                {showErrorComment && (
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <p className="redText">Comment can't be blank</p>
                  </div>
                )}
              </Row>
            </Column>
          </Row>
        )}

        <Row className="-centred-content">
          <Column>
            {sortedComments.map((item, index) => {
              if (index <= 3) {
                return (
                  <div key={index} style={{ marginTop: 20, marginBottom: 10 }}>
                    <Row>
                      <Label attr="Comment" text="Flag Date" />
                      <p className="dateText">
                        {SpecialCashbackRatePresenter.createdAtReadableItem(
                          item?.createdAt
                        )}
                      </p>
                    </Row>
                    <textarea
                      id="comment"
                      value={item?.comment}
                      readOnly
                      className="textarea"
                    />
                  </div>
                );
              }
            })}
            {specialCashbackRates.length > 4 && (
              <text
                className="blueText underline"
                onClick={() => setShowAllHistory(true)}
              >
                Show History
              </text>
            )}
          </Column>
        </Row>
      </Group>

      <Modal
        title="Flag History"
        isModalOpen={showAllHistory}
        onClose={() => setShowAllHistory(false)}
      >
        <Column>
          {sortedComments.map((item, index) => (
            <div key={index} style={{ marginTop: 20, marginBottom: 10 }}>
              <Row>
                <Label attr="Comment" text="Flag Date" />
                <p className="dateText">
                  {SpecialCashbackRatePresenter.createdAtReadableItem(
                    item?.createdAt
                  )}
                </p>
              </Row>
              <textarea
                id="comment"
                value={item?.comment}
                readOnly
                className="textarea"
              />
            </div>
          ))}
        </Column>
        <div className="modal-actions">
          <button
            className="button -in-group"
            onClick={() => setShowAllHistory(false)}
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default CashbackInfo;

CashbackInfo.propTypes = {
  fastCash: FastCashPresenter.shape().isRequired,
};
